import { gql } from '@apollo/client';

export const GET_LIST_TRANSACTIONS = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetTransactionList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Transactions {
        data {
          id
          documents {
            ... on PaginationResponse {
              count
            }
            ... on Documents {
              data {
                id
                name
                file_size
                file_type
                object_name
                bucket_name
                url_link
                created_at
                deleted_at
                updated_at
              }
            }
          }
          license_id
          license {
            ... on License {
              id
              user_type
              name
              description
              notes
              monthly_price
              annual_price
              biennial_price
              max_team_member
              max_socmed_account
              created_at
              updated_at
              deleted_at
            }
          }
          team_id
          team {
            ... on Team {
              id
              name
              partner
              limit
              start_date
              end_date
              type
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
              team_owner {
                ... on User {
                  id
                  email
                  name
                  active_status
                  default_team_id
                  created_at
                  updated_at
                  deleted_at
                }
              }
            }
          }
          bank_id
          description
          status
          discount
          dept
          doc_number
          receipt_number
          renewal_type
          team_license_id
          team_license {
            ... on TeamLicense {
              name
              user_type
              is_expired
              max_team_member
              max_socmed_account
              team_license_detail {
                ... on TeamLicenseDetail {
                  id
                  role_id
                  paid_at
                  expired_at
                  grace_expired_at
                  license_type_id
                  kuota
                  subscription_type
                  monthly_price
                  annual_price
                  biennial_price
                  discount
                }
              }
            }
          }
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LIST_TRANSACTIONS_TEAM_SETTING = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetTransactionList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Transactions {
        data {
          id
          documents {
            ... on PaginationResponse {
              count
            }
            ... on Documents {
              data {
                id
                name
                file_size
                file_type
                object_name
                bucket_name
                url_link
                created_at
                deleted_at
                updated_at
              }
            }
          }
          team_id
          team {
            ... on Team {
              id
              name
              partner
              limit
              start_date
              end_date
              type
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
              team_owner {
                ... on User {
                  id
                  email
                  name
                  active_status
                  default_team_id
                  created_at
                  updated_at
                  deleted_at
                }
              }
            }
          }
          bank_id
          description
          status
          discount
          dept
          doc_number
          receipt_number
          renewal_type
          team_license_id
          team_license {
            ... on TeamLicense {
              license_id
              name
              user_type
              is_expired
              max_team_member
              max_socmed_account
              team_license_detail {
                ... on TeamLicenseDetail {
                  id
                  role_id
                  paid_at
                  expired_at
                  grace_expired_at
                  license_type_id
                  kuota
                  subscription_type
                  monthly_price
                  annual_price
                  biennial_price
                  discount
                }
              }
            }
          }
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
